/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PriceListModel { 
    prcshid?: string | null;
    descexpr?: string | null;
    ntproonly?: number;
    active?: number;
    strtdate?: string;
    enddate?: string;
    promo?: number;
    curncyid?: string | null;
    deX_ROW_ID?: number;
    readonly ntproonlyDisplay?: string | null;
    readonly activeDisplay?: string | null;
    readonly promoDisplay?: string | null;
}

